import { render, staticRenderFns } from "./loveList.vue?vue&type=template&id=27818441&scoped=true&"
import script from "./loveList.vue?vue&type=script&lang=js&"
export * from "./loveList.vue?vue&type=script&lang=js&"
import style0 from "./loveList.vue?vue&type=style&index=0&id=27818441&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27818441",
  null
  
)

export default component.exports